import { Button } from '@mybridge/ui/button';
import { HStack } from '@mybridge/ui/layout';
import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@mybridge/ui/modal';
import { Textarea } from '@mybridge/ui/text-area';
import { useContext, useState } from 'react';
import { PostBoxContext } from '../../context';
import { useTranslator } from '@mybridge/ui/custom-hooks/useTranslation';
import { useDirection } from '@mybridge/ui/custom-hooks/useDirection';

export const PostBoxNotInterestedModal = ({ ...props }) => {
  const [comment, setComment] = useState();
  const { t } = useTranslator();
  const direction = useDirection();
  const { post, ignorePost, ignorePostLoading } = useContext(PostBoxContext);

  const handleIgnorePost = () => {
    const payload = {
      id: post?.id,
    };
    ignorePost(payload);
  };
  return (
    <>
      <Modal {...props}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>
            <ModalCloseButton {...(direction === 'rtl') ? {left: '0.75rem', right: 'auto'} : {left: 'auto', right: '0.75rem'}} />
            {t('otherModules.not_interested') || "Not interested?"}
          </ModalHeader>
          <ModalBody>
            <Textarea
              value={comment}
              onChange={(e) => setComment(e?.target?.value)}
              placeholder={`${t('otherModules.optional_comment') || "Optional Comment"}...`}
            />
          </ModalBody>
          <ModalFooter>
            <HStack justifyContent="flex-end">
              <Button borderRadius="full" onClick={props?.onClose} variant="secondary">
                {t('buttons.cancel') || "Cancel"}
              </Button>
              <Button
                isLoading={ignorePostLoading}
                onClick={handleIgnorePost}
                borderRadius="full"
                variant="primary"
              >
                {t('myDisk.submit') || "Submit"}
              </Button>
            </HStack>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};
